import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Spinkit } from './spinkits';

@Component({
    selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss', './spinkit-css/sk-line-material.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SpinnerComponent implements OnDestroy {
  public isSpinnerVisible = true;
  public Spinkit = Spinkit;
  @Input() public backgroundColor = '#1dc4e9';
  @Input() public spinner = Spinkit.skLine;

  ngOnDestroy(): void {
    this.isSpinnerVisible = false;
  }
}
